import React from "react";
import {
    Select,
    Checkbox,
    Row,
    Col,
    Button,
    Space,
    DatePicker,
    Modal,
    Dropdown,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import FuelConsumptionReportStore from "../store/FuelConsumptionReportStore";
import { CaretDownOutlined, CaretUpOutlined, DownOutlined, PlusOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
const { RangePicker } = DatePicker;
const { Option } = Select;

class FuelConsumptionReportList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.FuelConsumptionReportStore = new FuelConsumptionReportStore()
        this.vehicleStore = new VehicleStore();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            selectedVehicles: [],
            selectAllVehicles: false,
            companyId: "",
            modalVisible: false,
            column: "",
            filter: "",
            showMonthPopup: false,
            Notcompany: false,
            Notasset: false,
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            Notdate: false,
            vehicleObj: false,
            heading: "",
            showTable: true,
            showtotaltable: false,
            selectedColumns: [
                {
                    title: context.translate("_VEHICLE_NO_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                },
                {
                    title: context.translate("_DATE_"),
                    dataIndex: "date",
                    key: "date",
                },
                {
                    title: context.translate("_DISTANCE_"),
                    dataIndex: "distance",
                    key: "distance",
                },

                {
                    title: context.translate("_START_FUEL_"),
                    dataIndex: "firstFuel",
                    key: "firstFuel",
                },
                {
                    title: context.translate("_END_FUEL_"),
                    dataIndex: "lastFuel",
                    key: "lastFuel",
                },
                {
                    title: context.translate("_REFILL_FUEL_LEVEL_LTRS_"),
                    dataIndex: "refillfuel",
                    key: "refillfuel",
                },
                {
                    title: context.translate("_CONSUMPTION_AT_IDLE_"),
                    dataIndex: "totalIdle",
                    key: "totalIdle",
                },
                {
                    title: context.translate("_TOTAL_FUEL_CONSUMPTION_"),
                    dataIndex: "totalConsumption",
                    key: "totalConsumption",
                },
                {
                    title: context.translate("_THEFT_"),
                    dataIndex: "theftFuel",
                    key: "theftFuel",
                },
            ],
        };

        this.newColumns = [...this.state.selectedColumns];
    }
    async componentDidMount() {
        this.totalColumns = [
            {
                title: this.context.translate(
                    "_VEHICLE_NO_"
                ),
                dataIndex: "vehicleNo",
                width: "15%",
            },
            {
                title: this.context.translate("_DISTANCE_"),
                dataIndex: "totalDistance",
                width: "15%",
            },

            {
                title: this.context.translate("_TOTAL_FUEL_CONSUMPTION_"),
                dataIndex: "totalFuelConsumed",
                width: "15%",
            },
            {
                title: this.context.translate("_TOTAL_IDLE_CONSUMPTION_"),
                dataIndex: "totalIdleConsumed",
                width: "15%",
            },
            {
                title: this.context.translate("_TOTAL_THEFT_"),
                dataIndex: "totalTheft",
                width: "15%",
            },
        ];
        this.menuProps = {
            items: [
                {
                    label: this.context.translate("_EXCEL_"),
                    key: "excel",
                    icon: <PlusOutlined />,
                },
                {
                    label: this.context.translate("_PDF_"),
                    key: "pdf",
                    icon: <PlusOutlined />,
                },
                {
                    label: this.context.translate("_TOTAL_EXCEL_"),
                    key: "totalexcel",
                    icon: <PlusOutlined />,
                },
                {
                    label: this.context.translate("_TOTAL_PDF_"),
                    key: "totalpdf",
                    icon: <PlusOutlined />,
                },
            ],
            onClick: (val) => {
                let result = [];
                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    var getData = {
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        colList: result.toString(),
                    };
                    if (val.key === "excel") {
                        this.FuelConsumptionReportStore.exportExcel(getData);
                    }
                    if (val.key === "pdf") {
                        this.FuelConsumptionReportStore.exportpdf(getData);
                    }
                    if (val.key === "totalexcel") {
                        this.FuelConsumptionReportStore.exportTotalExcel(getData);
                    }
                    if (val.key === "totalpdf") {
                        this.FuelConsumptionReportStore.exportTotaltpdf(getData);
                    }
                }
            },
        };
        this.setState({ pageSize: 50 });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        this.setState({ selectedVehicles: [], selectAllVehicles: false });
        this.setState({ selectedDriver: [], selectAllDrivers: false });

        await this.setState({ companyId: comp?.value });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);

        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ Notasset: false });
        // await this.fuelRefilledReportStore.loadData({
        //   offset: (this.state.currentPage - 1) * this.state.pageSize,
        //   limit: this.state.pageSize,
        //   companyId: this.state.companyId,
        //   pageNo: this.state.currentPage,
        // });
        await this.setState({ loadData: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.showData();
    }

    showData = async () => {
        this.setState({ loading: true });
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.selectedVehicles) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (!this.state.fromDate) {
            this.setState({ Notdate: true });
        } else {
            this.setState({ Notdate: false });
        }

        if (
            this.state.companyId &&
            this.state.selectedVehicles &&
            this.state.fromDate &&
            this.state.toDate
        ) {
            this.setState({ Notcompany: false, Notasset: false, Notdriver: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.FuelConsumptionReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    vehicleId: this.state.selectedVehicles,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    pageNo: this.state.currentPage,
                });
                this.setState({ loading: true });
            }
        }
    };

    handleCheckboxChange = async (column) => {
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };
    addMonths = (date, months) => {

        var indx = dayjs().month() + -6;
        return dayjs().month(indx);
    };

    checkFromDate(dates) {
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {

            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" });
        }
    };

    handleAllSelectVehicles = async () => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    showTotal = async () => {
        await this.FuelConsumptionReportStore?.totalFuelConsumptionReport({
            // offset: (this.state.pageNo - 1) * this.state.pageSize,
            // limit: this.state.pageSize,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
        });
        await this.setState({ loadData: 1 });
    };

    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_FUEL_CONSUMPTION_REPORT_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction === "ltr" ? "right" : "left",
                                }}
                            >
                                <Button
                                    onClick={async () => {
                                        await this.showTotal();
                                        await this.setState({
                                            showTable: false,
                                            showtotaltable: true,
                                        });
                                    }}
                                >

                                    {this.context.translate("_TOTAL_")}
                                </Button>

                                <Button onClick={() => this.setState({ modalVisible: true })}>

                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                                <Dropdown
                                    menu={this.menuProps}
                                    disabled={
                                        this.FuelConsumptionReportStore?.fuelconsumptionReport?.length > 0 ? false : true
                                    }
                                >
                                    <Button className="exportDropdown">
                                        <Space>
                                            {this.context.translate("_EXPORT_")}
                                            <DownOutlined />
                                        </Space>
                                    </Button>
                                </Dropdown>




                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    allowClear={true}
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                {this.props.getUserData().isadmin === 1 && (
                                    <DeviceGroupsForVehicles
                                        vehicleStore={this.vehicleStore}
                                        setLoadDta={() => this.setState({ loadData: 1 })}
                                        resetVehicles={() =>
                                            this.setState({
                                                selectedVehicles: [],
                                                selectAllVehicles: false,
                                            })
                                        }
                                    />
                                )}
                                {/* <Checkbox
                                    checked={this.state.selectAllVehicles}
                                    onChange={async (e) => {
                                        await this.setState({
                                            selectAllVehicles: e.target.checked,
                                        });
                                        await this.handleAllSelectVehicles();
                                    }}
                                />
                                {this.context.translate("_ALL_")} */}

                                <Select
                                    className="searchInput"
                                    // maxTagCount="responsive"
                                    value={this.state.selectedVehicles ? this.state.selectedVehicles : null}
                                    onChange={(val) => {
                                        this.setState({ selectedVehicles: val });
                                        if (
                                            this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllVehicles: false });
                                        } else {
                                            this.setState({ selectAllVehicles: true });
                                        }
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    // mode="multiple"
                                    placeholder={this.context.translate(
                                        "_VEHICLE_NO_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option key={val.vehicleId} value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>

                                <RangePicker
                                    status={this.state.Notdate ? "error" : false}
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    //  disabledDate={(current) => { 
                                    //     return current && current > dayjs();
                                    //   }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [
                                            dayjs().startOf("day"),
                                            dayjs().endOf("day"),
                                        ],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                                />
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                        await this.setState({
                                            showTable: true,
                                            showtotaltable: false,
                                        });
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>

                            </Space>
                        </Col>

                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <div
                        className="accordion-list"
                        onClick={() =>
                            this.setState({
                                showTable: !this.state.showTable,
                                showtotaltable: !this.state.showtotaltable,
                            })
                        }
                    >
                        {this.context.translate("_FUEL_CONSUMPTION_REPORT_")}
                        <Button >
                            {this.state.showTable ? <CaretDownOutlined /> : <CaretUpOutlined />}
                        </Button>
                    </div>
                    {this.state.showTable && (
                        <ListTable
                            currentPage={this.state.currentPage}
                            pageSize={this.state.pageSize}
                            total={this.FuelConsumptionReportStore?.total}
                            columns={this.state.column}
                            dataSource={this.FuelConsumptionReportStore?.fuelconsumptionReport}
                            loading={this.FuelConsumptionReportStore?.loading}
                            onChange={this.handleTableChange}
                        />)}

                    <div
                        className="accordion-list"
                        onClick={() =>
                            this.setState({
                                showtotaltable: !this.state.showtotaltable,
                                showTable: !this.state.showTable,
                            })
                        }
                    >
                        {" "}
                        {this.context.translate("_TOTAL_FUEL_CONSUMPTION_REPORT_")}
                        <Button >
                            {this.state.showtotaltable ? <CaretDownOutlined /> : <CaretUpOutlined />}
                        </Button>{" "}
                    </div>

                    {this.state.showtotaltable && (
                        <ListTable
                            currentPage={this.state.currentPage}
                            // total={this.idleReportStore?.total}
                            pagination={false}
                            columns={this.totalColumns}
                            dataSource={this.FuelConsumptionReportStore?.totalIdleArray}
                            loading={this.FuelConsumptionReportStore?.loadingData}
                        // onChange={this.handleTableChange}

                        />
                    )}

                    <Modal
                        width={350}
                        className="alert-model"
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        open={this.state.showMonthPopup}
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>
                </div >
            </>
        );
    }
}
FuelConsumptionReportList.contextType = StoreContext;
export default observer(withRouter(FuelConsumptionReportList));
